import React from 'react';

const StatusBanners = ({ subscriptionStatus, cancelAtPeriodEnd, billingStatus, onOpenPortal, disabled = false, disabledTooltip }) => (
  <>
    {subscriptionStatus === 'past_due' && (
      <div className="rounded-lg p-4 border bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800">
        <p className="text-sm font-medium text-red-800 dark:text-red-200">
          Your payment failed. Please update your payment method to avoid service interruption.
        </p>
        <button
          onClick={onOpenPortal}
          disabled={disabled}
          title={disabled ? disabledTooltip : undefined}
          className="mt-2 text-sm font-semibold text-red-700 dark:text-red-300 underline disabled:opacity-50 disabled:no-underline disabled:cursor-not-allowed"
        >
          Update Payment Method
        </button>
        {disabled && disabledTooltip && (
          <p className="mt-1 text-xs text-red-700/80 dark:text-red-300/80">{disabledTooltip}</p>
        )}
      </div>
    )}

    {subscriptionStatus === 'grace_period' && (
      <div className="rounded-lg p-4 border bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
          Your subscription has ended. You have until{' '}
          {billingStatus?.subscription?.grace_period_end
            ? new Date(billingStatus.subscription.grace_period_end).toLocaleDateString()
            : '7 days'}{' '}
          to resubscribe before your account is downgraded to the Free plan.
        </p>
      </div>
    )}

    {cancelAtPeriodEnd && subscriptionStatus !== 'grace_period' && subscriptionStatus !== 'past_due' && (
      <div className="rounded-lg p-4 border bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
          Your subscription will cancel on{' '}
          {new Date(billingStatus.subscription.current_period_end).toLocaleDateString()}.
          Your credits and features will remain active until then.
        </p>
      </div>
    )}

    {billingStatus?.subscription?.pending_plan_change && !cancelAtPeriodEnd && (
      <div className="rounded-lg p-4 border bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
        <p className="text-sm font-medium text-blue-800 dark:text-blue-200">
          Your plan will change to{' '}
          <span className="font-bold">{billingStatus.subscription.pending_plan_change.display_name}</span>{' '}
          on {new Date(billingStatus.subscription.pending_plan_change.effective_date).toLocaleDateString()}.
          Your current plan remains active until then.
        </p>
      </div>
    )}

    {billingStatus?.subscription?.payment_processing && (
      <div className="rounded-lg p-4 border bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
          Your payment is being processed. Your plan will upgrade to{' '}
          <span className="font-bold capitalize">{billingStatus.subscription.payment_processing.pending_plan}</span>{' '}
          once confirmed.
        </p>
      </div>
    )}
  </>
);

export default StatusBanners;
